import { format } from 'date-fns';

export default function (val: any, formatStr: any, local: any) {
  return val && format(new Date(val), formatStr, local);
}
